var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.contractLogInfo.contractLogItemList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "tblName",
              label: "业务主体",
              width: "180",
              align: "left"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "subName",
              label: "变动主体",
              width: "180",
              align: "left",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "fldName", label: "数据项", align: "left" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "oldValue", label: "上一版", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.oldValue == "false"
                      ? _c("span", [_vm._v("否")])
                      : rows.row.oldValue == "true"
                      ? _c("span", [_vm._v("是")])
                      : _c("span", [_vm._v(_vm._s(rows.row.oldValue))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "newValue", label: "当前版", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.newValue == "false"
                      ? _c("span", [_vm._v("否")])
                      : rows.row.newValue == "true"
                      ? _c("span", [_vm._v("是")])
                      : _c("span", [_vm._v(_vm._s(rows.row.newValue))])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69bda8d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69bda8d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractLogInfo.vue
// module id = 2114
// module chunks = 0